<script>
import deepLink from '@/mixins/deeplink.js'

export default {
  name: 'ErrorTicketCreation',
  components: {},
  mixins: [deepLink()],
  props: {},
  computed: {},
  created () { },
  methods: {},
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__content">
      <img
        class="container__logo"
        src="@assets/images/error.svg"
        alt="error-icon"
      >
      <h2>{{ $t('WIDGETS.COMMON.REQUEST_ERROR') }}</h2>
    </div>
  </div>
</template>


<style lang="scss" scoped module>
@import '@design';

.container {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  min-height: 75vh;

  &__content {
    padding: 4rem;

    img {
      max-width: 7rem;
      max-height: 7rem;
      margin-bottom: 0.8rem;
    }

    h2 {
      @extend %typography-large;

      margin-top: 1.5rem;
      color: $secondary-text;
    }
  }

  &__button {
    position: absolute;
    bottom: 2rem;
  }
}
</style>
